// extracted by mini-css-extract-plugin
module.exports = {"container":"AddMoreDataButton_container__2WYPT","button":"AddMoreDataButton_button__1mbRu","icon":"AddMoreDataButton_icon__-lqHQ","text":"AddMoreDataButton_text__2b-0b"};